import { render, staticRenderFns } from "./UpcomingChangesModal.vue?vue&type=template&id=4ff22fa2&scoped=true&"
import script from "./UpcomingChangesModal.vue?vue&type=script&lang=js&"
export * from "./UpcomingChangesModal.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingChangesModal.vue?vue&type=style&index=0&id=4ff22fa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff22fa2",
  null
  
)

component.options.__file = "UpcomingChangesModal.vue"
export default component.exports